import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["amount", "includeFee", "feeLabel", "total", "form", "cardNumber", "cardCvv", "expMonth", "expYear", "cardToken", "submitButton", "formContainer", "errors"]

  connect() {
    this.recalculate()
  }

  recalculate() {
    const amount = parseFloat(this.amountTarget.value) || 0
    const fee = this.calculateFee(amount)

    if (fee > 0) {
      this.feeLabelTarget.textContent = `I would like to pay the $${fee.toFixed(2)} credit card transaction fee`
    }

    let total = amount
    if (this.includeFeeTarget.checked) {
      total += fee
    }

    if (total > 0) {
      this.totalTarget.value = total.toFixed(2)
    } else {
      this.totalTarget.value = "0.00"
    }
  }

  calculateFee(amount) {
    const flatFee = 0.30
    const discountFee = this.calcDiscountFee(amount + flatFee)
    return discountFee + flatFee
  }

  calcDiscountFee(amount) {
    if (amount.toFixed(2) > 0.0) {
      const fee = amount * 0.029
      return fee + this.calcDiscountFee(fee)
    }
    return 0.0
  }

  formatCurrency(event) {
    const amount = parseFloat(event.target.value)
    if (!isNaN(amount)) {
      event.target.value = amount.toFixed(2)
    }
  }

  submit(event) {
    event.preventDefault()

    if (!this.validate()) return

    this.submitButtonTarget.disabled = true

    Stripe.card.createToken(
      {
        number: this.cardNumberTarget.value,
        cvc: this.cardCvvTarget.value,
        exp_month: this.expMonthTarget.value,
        exp_year: this.expYearTarget.value
      },
      (status, response) => this.stripeResponseHandler(status, response)
    )
  }

  stripeResponseHandler(status, response) {
    if (response.error) {
      this.showError(response.error.message)
      this.submitButtonTarget.disabled = false
    } else {
      this.cardTokenTarget.value = response.id
      // Remove sensitive card fields before submit
      this.cardNumberTarget.remove()
      this.cardCvvTarget.remove()
      this.showProcessing()
      this.formTarget.submit()
    }
  }

  validate() {
    const errors = []
    if (!this.element.querySelector("[name='donation[full_name]']").value.trim()) errors.push("Full name is required")
    if (!this.element.querySelector("[name='donation[email]']").value.trim()) errors.push("Email is required")
    if (!this.element.querySelector("[name='donation[telephone]']").value.trim()) errors.push("Telephone is required")
    if (!this.cardNumberTarget.value.trim()) errors.push("Card number is required")
    if (!this.cardCvvTarget.value.trim()) errors.push("CVV is required")

    const amount = parseFloat(this.amountTarget.value)
    if (!amount || amount <= 0) errors.push("Amount must be greater than 0")

    if (errors.length > 0) {
      this.showError(errors.join(", "))
      return false
    }
    return true
  }

  showError(message) {
    this.errorsTarget.textContent = message
    this.errorsTarget.classList.remove("hidden")
  }

  showProcessing() {
    this.formTarget.classList.add("hidden")
    this.formContainerTarget.insertAdjacentHTML("beforeend", `
      <div class="text-center py-12">
        <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
        <h2 class="text-xl font-bold mt-4">Processing...</h2>
        <p class="text-gray-600 mt-2">Please do not refresh the page until processing has finished.</p>
      </div>
    `)
  }
}
